// src/components/Preloader.jsx
import React from 'react';

const Preloader = () => (
  <div className="fixed top-0 left-0 right-0 bottom-0 flex items-center justify-center z-[1300] bg-white">
    <span className="loading loading-spinner loading-lg bg-primary"></span>
  </div>
);

export default Preloader;
